// @flow

import {
  SET_AVAILABLE_FILTER_ENTITIES,
  SET_COVERED_PERIOD,
  SET_ENGRAVED_ID,
  SET_EXPIRY_REMINDER,
  SET_PRODUCT_CONFIGURATIONS,
  SET_SELECTED_CLASS,
  SET_SELECTED_CUSTOMER_GROUP,
  SET_SELECTED_FROM_STOP,
  SET_SELECTED_PRODUCT,
  SET_SELECTED_STAR_VALUE,
  SET_SELECTED_TERM,
  SET_SELECTED_TO_STOP,
  SET_SELECTED_ZONE,
  SET_DATE_EFFECTIVE,
  SET_PRE_SELECTED_ZONE_ID,
  SET_PRE_SELECTED_ZONE_CODE,
  SET_PRE_SELECTED_STAR_VALUE_ID,
  SET_PRE_SELECTED_CLASS_ID,
  SET_PRE_SELECTED_FROM_STOP_ID,
  SET_PRE_SELECTED_TO_STOP_ID,
  RESET,
  SET_RENEW_SUBSCRIPTION_ID,
  SET_SPECIAL_SALE_SLUG,
  SET_SESSION_ID
} from './mutation-types'
import type { ConfigurationState } from './state'
import type { ConfigurationFilterEntitySet } from '../../../types/configuration-filter-entity-set'
import ProductConfiguration from '../../../types/product-configuration'
import type { DateString } from '../../../types/date-string'
import type { Product } from '../../../types/filter-entity/product'
import type { Term } from '../../../types/filter-entity/term'
import type { Stop } from '../../../types/filter-entity/stop'
import type { ProductClass } from '../../../types/filter-entity/class'
import type { StarValue } from '../../../types/filter-entity/star-value'
import type { Zone } from '../../../types/filter-entity/zone'
import type { CustomerGroup } from '../../../types/filter-entity/customer-group'
import type { Period } from '../../../types/period'

export default {
  [SET_AVAILABLE_FILTER_ENTITIES]: (state: ConfigurationState, value: ConfigurationFilterEntitySet) => {
    state.availableFilterEntities = value
  },
  [SET_PRODUCT_CONFIGURATIONS]: (state: ConfigurationState, value: ProductConfiguration[]) => {
    state.productConfigurations = value
  },
  [SET_DATE_EFFECTIVE]: (state: ConfigurationState, value: ?DateString) => {
    state.dateEffective = value
  },
  [SET_SELECTED_PRODUCT]: (state: ConfigurationState, value: ?Product) => {
    state.selectedProduct = value
  },
  [SET_SELECTED_CUSTOMER_GROUP]: (state: ConfigurationState, value: ?CustomerGroup) => {
    state.selectedCustomerGroup = value
  },
  [SET_SELECTED_TERM]: (state: ConfigurationState, value: ?Term) => {
    state.selectedTerm = value
  },
  [SET_SELECTED_FROM_STOP]: (state: ConfigurationState, value: ?Stop) => {
    state.selectedFromStop = value
  },
  [SET_PRE_SELECTED_FROM_STOP_ID]: (state: ConfigurationState, value: ?string) => {
    state.preSelectedFromStopId = value
  },
  [SET_SELECTED_TO_STOP]: (state: ConfigurationState, value: ?Stop) => {
    state.selectedToStop = value
  },
  [SET_PRE_SELECTED_TO_STOP_ID]: (state: ConfigurationState, value: ?string) => {
    state.preSelectedToStopId = value
  },
  [SET_SELECTED_CLASS]: (state: ConfigurationState, value: ?ProductClass) => {
    state.selectedClass = value
  },
  [SET_PRE_SELECTED_CLASS_ID]: (state: ConfigurationState, value: ?string) => {
    state.preSelectedClassId = value
  },
  [SET_SELECTED_STAR_VALUE]: (state: ConfigurationState, value: ?StarValue) => {
    state.selectedStarValue = value
  },
  [SET_PRE_SELECTED_STAR_VALUE_ID]: (state: ConfigurationState, value: ?string) => {
    state.preSelectedStarValueId = value
  },
  [SET_SELECTED_ZONE]: (state: ConfigurationState, value: ?Zone) => {
    state.selectedZone = value
  },
  [SET_PRE_SELECTED_ZONE_ID]: (state: ConfigurationState, value: ?string) => {
    state.preSelectedZoneId = value
  },
  [SET_PRE_SELECTED_ZONE_CODE]: (state: ConfigurationState, value: ?string) => {
    state.preSelectedZoneCode = value
  },
  [SET_COVERED_PERIOD]: (state: ConfigurationState, value: ?Period) => {
    state.coveredPeriod = value
  },
  [SET_EXPIRY_REMINDER]: (state: ConfigurationState, value: boolean) => {
    state.expiryReminder = value
  },
  [SET_ENGRAVED_ID]: (state: ConfigurationState, value: string) => {
    state.engravedId = value
  },
  [SET_RENEW_SUBSCRIPTION_ID]: (state: ConfigurationState, value: ?string) => {
    state.renewSubscriptionId = value
  },
  [SET_SPECIAL_SALE_SLUG]: (state: ConfigurationState, value: ?string) => {
    state.specialSaleSlug = value
  },
  [RESET]: (state: ConfigurationState) => {
    state.availableFilterEntities = {
      customerGroups: [],
      classes: [],
      terms: [],
      zones: [],
      starValues: [],
      stops: []
    }
    state.dateEffective = null
    state.selectedProduct = null
    state.selectedCustomerGroup = null
    state.selectedTerm = null
    state.selectedFromStop = null
    state.preSelectedFromStopId = null
    state.selectedToStop = null
    state.preSelectedToStopId = null
    state.selectedClass = null
    state.preSelectedClassId = null
    state.selectedStarValue = null
    state.preSelectedStarValueId = null
    state.selectedZone = null
    state.preSelectedZoneId = null
    state.preSelectedZoneCode = null
    state.coveredPeriod = null
    state.expiryReminder = true
    state.engravedId = ''
    state.renewSubscriptionId = null
    state.specialSaleSlug = null
    state.productConfigurations = []
    state.sessionId = null
  },
  [SET_SESSION_ID]: (state: ConfigurationState, sessionId: ?string) => {
    state.sessionId = sessionId
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/configuration/mutations.js